module.exports = __webpack_public_path__ + "img/Save State_Over.60326f3c.svg";